import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { useWatch } from 'react-hook-form';
import BadgeMask from '@/components/Badge/BadgeMask';
import Avatar from '@/components/Custom/Avatar';
import * as Header from '@/components/Custom/Header';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';

export default function BadgeEditHeader({ canDelete }: { canDelete: boolean }) {
  const { navigate } = useRouter();
  const color = useWatch({ name: 'color' });
  const title = useWatch({ name: 'title' });
  const { badgeId } = useLocalSearchParams<{
    badgeId?: string;
  }>();
  const displayTitle = title?.trim()
    ? title
    : !badgeId
      ? 'New Badge'
      : 'Edit Badge';
  const displaySubtitle = badgeId ? 'Edit Badge' : 'Create Badge';

  const headerTitle = () => (
    <Header.TitleContainer>
      <BadgeMask size="md" color={color}>
        <Avatar
          ring={false}
          size="md"
          color={color || ''}
          name={displayTitle}
        />
      </BadgeMask>
      <Box flex>
        <Text
          flexShrink={1}
          numberOfLines={1}
          size="xl"
          testID="BadgeEditHeaderTitle"
        >
          {displayTitle}
        </Text>
        <Box flex direction="horizontal" alignItems="center" space="sm">
          <Icon variant="typographySecondary" name="ribbon-outline" size="sm" />
          <Text variant="typographySecondary" size="xs" numberOfLines={1}>
            {displaySubtitle}
          </Text>
        </Box>
      </Box>
    </Header.TitleContainer>
  );

  const onPressDelete = () => {
    if (!badgeId) {
      return;
    }

    navigate({
      pathname: '/badge/[badgeId]/delete',
      params: { badgeId },
    });
  };

  const headerRight = () =>
    canDelete ? (
      <Header.End>
        <Header.ButtonGroup>
          <Header.Button
            accessibilityLabel="Delete badge"
            testID="BadgeEditDeleteButton"
            onPress={onPressDelete}
          >
            <Icon name="trash-outline" size="2xl" />
          </Header.Button>
        </Header.ButtonGroup>
      </Header.End>
    ) : null;

  return (
    <Stack.Screen
      options={{
        headerRight,
        headerTitle,
        title: displaySubtitle,
      }}
    />
  );
}
